import { css } from '@emotion/css';
import { Color, Font } from 'src/styles';

export const mailOpenIcon = css`
  ${Font.h5}
  color: ${Color.Green6};
`;
